import store from '@/store';

export default (to, from, next) => ({
    allow: store.getters.is_show_ufb_module,
    redirect: { name: 'not-found' },
})